<template>
  <section class="home">
    <Loading/>
    <Toast :show="$bus.toast.show"/>
    <section class="main">
      <ff-header/>
      <section class="inner">
        <ff-pool/>
        <ff-process/>
        <ff-plate/>
      </section>
      <ff-footer/>
    </section>
    <Buy/>
    <Refresh/>
    <Rule/>
    <History/>
    <Alert :show.sync="alertShow" :title="alertTitle" :content="alertContent"/>
    <EuPolicyAlert :show.sync="euPolicyShow" :content="euPolicyContent" :storageText="euPolicyChoiceContent.storageText" :adText="euPolicyChoiceContent.adText"></EuPolicyAlert>

  </section>
</template>
<script>
  import { setSessionStorage, getSessionStorage, initGA } from '@/utils/assist'
  import Toast from '@/components/common/Toast.vue'
  import Loading from '@/components/common/Loading.vue'
  import ffHeader from '@/components/common/Header.vue'
  import ffFooter from '@/components/common/Footer.vue'
  import Alert from '@/components/common/Alert.vue'
  import ffPool from '@/components/pool'
  import ffProcess from '@/components/process'
  import ffPlate from '@/components/plate'
  import Buy from '@/components/buy'
  import Refresh from '@/components/refresh'
  import Rule from '@/components/rule'
import History from '@/components/history'
  import EuPolicyAlert from '@/components/base/EuPolicyAlert.vue'
import { euData, euPopupInject } from '@/utils/eu_popup'
  export default {
    name: 'home',
    data () {
      return {
        globalConfig: this.$bus.$data, // 全局被观测数据对象
        alertShow: false,
        alertTitle: '',
        alertContent: '',
        ...euData
      }
    },
    components: {
      Toast,
      Loading,
      ffHeader,
      ffFooter,
      ffPool,
      ffProcess,
      ffPlate,
      Buy,
      Refresh,
      Rule,
      History,
      Alert,
      EuPolicyAlert
    },
    methods: {
      initInfo () {
        let accessToken = getSessionStorage(`${PROJECT_NAME}AccessToken`) || ''
        let lang = getSessionStorage(`${PROJECT_NAME}Lang`) || ''
        if (!accessToken) return this.$bus.handleError('TOAST_LOGIN_FAILED')
        this.$api
          .info({
            access_token: accessToken,
            lang: lang
          })
          .then(response => {
            let data = response.data
            this.googleAnalyticsPopupInject(data)
            if (data['policy_popup']) {
              const { popup_title: policyTitle, popup_content: policyCtx, checked: policyHide } = data['policy_popup']
              this.alertShow = !policyHide
              this.alertTitle = policyTitle
              this.alertContent = policyCtx
            }
            let dataLogName = data['data_log_name'] || ''
            this.$bus.uid = data.uid
            this.$bus.gems = data.gem
            this.initActInfo(
              data.free_refresh_used,
              data.free_refresh_limit,
              data.paid_refresh_used,
              data.paid_refresh_limit,
              data.refresh_payment_required,
              data.refresh_cost,
              data.discounts,
              data.end_time)
            this.$bus.setComPool(data.pool, data.pool_bought) // 初始化商品池
            this.$bus.transify = data.transify
            this.$bus.rule.content = data.rule
            this.$bus.history.data = data.history
            document.body.setAttribute('data-lang', data.lang)
            initGA(data.region, this.$bus.actInfo.uid, dataLogName)
          })
      },
      initActInfo (freeUsedTimes, freeAllTimes, payUsedTimes, payAllTimes, refreshStatus, refreshCost, discounts, endTime) {
        this.$bus.actInfo = {
          freeUsedTimes: freeUsedTimes,
          freeAllTimes: freeAllTimes,
          payUsedTimes: payUsedTimes,
          payAllTimes: payAllTimes,
          refreshStatus: refreshStatus, // 下次刷新是否需要支付钻石
          refreshCost: refreshCost,
          discounts: discounts,
          endTime: endTime
        }
      },
      googleAnalyticsPopupInject: euPopupInject

    },
    mounted () {
      this.initInfo()
    }
  }
</script>
<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  background-size: 100% 100%;
  background-position-y: top;
  position: relative;
  .main {
    width: 100vw;
    height: 100vh;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .inner {
      @include pxres(height, 468);
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue